import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';

import Dialog from 'src/componentes/dialog';
import MdiIcon from 'src/componentes/mdi-icon';
import PerfilDossie from './PerfilDossie';
import ConfiguracaoDossieColaborador from './Configuracao';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/errorHandler';
import SecoesDossieColaborador from './Secoes';

const DossieColaborador = ({ colaboradorId }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const [isOpen, setIsOpen] = useState(true);
  const [showConfiguracoes, setShowConfiguracoes] = useState(false);
  const [permissaoConfiguracao, setPermissaoConfiguracao] = useState(false);

  const dossieRef = useRef();

  const handleClose = () => {
    setIsOpen(false);
    dossieRef.current?.close();
  };

  useEffect(() => {
    getPermissaoConfiguracao();
  }, []);

  const getPermissaoConfiguracao = async () => {
    try {
      const response = await http.get(
        'DossieColaborador/ObterPermissaoConfiguracao'
      );
      setPermissaoConfiguracao(response?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  if (!isOpen) return null;

  return (
    <Dialog ref={dossieRef} padContent width="90%" onClose={handleClose}>
      <div className="p-3">
        {showConfiguracoes ? (
          <ConfiguracaoDossieColaborador
            onClickBack={() => setShowConfiguracoes(false)}
          />
        ) : (
          <>
            <div className="d-flex px-4 justify-content-between text-2xl mb-2">
              <span className="text-primary font-weight-bolder">
                {intl.formatMessage(
                  { id: 'dossie' },
                  { dossie: resources.dossie }
                )}
              </span>
              {permissaoConfiguracao && (
                <MdiIcon
                  icon="cog"
                  className="text-primary"
                  size="24"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setShowConfiguracoes(true)}
                />
              )}
            </div>
            <div className="d-flex">
              <PerfilDossie colaboradorId={colaboradorId} />
              <SecoesDossieColaborador colaboradorId={colaboradorId} />
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default DossieColaborador;
